import React from "react";
import { Reveal } from "../shared/Reveal";

const BATTERY_INSTALLS = [
  { img: "/brand/battery/b5.jpg", label: "The Energy Vault Box", meta: "Containerised · Plug-and-play system" },
  { img: "/brand/battery/b4.jpg", label: "System Commissioning", meta: "On-site delivery & handover team" },
  { img: "/brand/battery/b2.jpg", label: "Outdoor Cabinet Install", meta: "Weatherproof modular cabinets" },
  { img: "/brand/battery/b3.jpg", label: "Site Delivery", meta: "Craned safely into position" },
];

const BATTERY_FEATURES = [
  {
    title: "20ft Container", body: "Compact design. Powerful performance in a small footprint.",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="12" rx="1.5" /><path d="M6 6v12M10 6v12M14 6v12M18 6v12" /></svg>,
  },
  {
    title: "High-Efficiency Batteries", body: "High efficiency, long life and safe by design.",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="7" width="16" height="10" rx="2" /><line x1="22" y1="11" x2="22" y2="13" /><path d="M11 9l-2 3h3l-2 3" /></svg>,
  },
  {
    title: "Smart Energy Management", body: "Real-time monitoring and continuous optimisation.",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h4l3 8 4-16 3 8h4" /></svg>,
  },
  {
    title: "Integrate & Save", body: "Seamlessly combines solar, grid and generator power.",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M12 2v4M12 18v4M2 12h4M18 12h4M5 5l2.5 2.5M16.5 16.5 19 19M19 5l-2.5 2.5M7.5 16.5 5 19" /></svg>,
  },
  {
    title: "Built to Perform", body: "Built in the UK. Built to last.",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5l-8-3Z" /><path d="m9 12 2 2 4-4" /></svg>,
  },
];

const BATTERY_BENEFITS = ["Reduce Energy Costs", "Lower Diesel Usage", "Protect Critical Operations", "Store Solar, Use Smarter", "Built in the UK"];

export default function BatteryStorage({ go }) {
  return (
    <section id="battery-storage" className="batterysec">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">BESPOKE ENERGY STORAGE</Reveal>
        <Reveal className="h2" tag="div">One Container. <span className="g">One Fully Engineered System.</span></Reveal>
        <Reveal className="lead" tag="p">The <b style={{ color: "#fff" }}>Energy Vault Box</b> is a complete, plug-and-play energy system housed within a container — designed, built and delivered ready to perform. No guesswork. No mismatched components. Just one fully engineered solution.</Reveal>

        <div className="solargrid">
          {BATTERY_INSTALLS.map((it, i) => (
            <Reveal className={`sgitem${i === 0 ? " big" : ""}`} tag="div" key={it.img} style={{ transitionDelay: `${i * 0.07}s` }} data-testid={`battery-install-${i}`}>
              <img src={it.img} alt={it.label} loading="lazy" />
              <div className="sgcap">
                <div className="sglabel">{it.label}</div>
                <div className="sgmeta">{it.meta}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="smallfoot" tag="div">Small Footprint. <span className="g">Big Performance.</span></Reveal>
        <Reveal className="smallfootsub" tag="p">Designed for organisations that demand reliability, efficiency and total control.</Reveal>

        <div className="batfeatures">
          {BATTERY_FEATURES.map((f, i) => (
            <Reveal className="batfeat" tag="div" key={f.title} style={{ transitionDelay: `${(i % 3) * 0.07}s` }} data-testid={`battery-feature-${i}`}>
              <div className="bficon">{f.icon}</div>
              <h4>{f.title}</h4>
              <p>{f.body}</p>
            </Reveal>
          ))}
        </div>

        <div className="batbenefits">
          {BATTERY_BENEFITS.map((b) => (
            <Reveal className="batpill" tag="span" key={b} data-testid={`battery-benefit-${b.split(" ")[0].toLowerCase()}`}><span className="bdot" />{b}</Reveal>
          ))}
        </div>

        <Reveal className="batterytag" tag="div" data-testid="battery-tagline">
          We don't sell boxes — <span className="g">we design energy systems that work.</span>
        </Reveal>

        <Reveal className="sgcta" tag="div">
          <a onClick={() => go("contact")} className="btn" data-testid="battery-cta">Design My Storage System</a>
        </Reveal>
      </div>
    </section>
  );
}
